const messages = {
  ES: {
    Common: {
      AccessCode: "Código de acceso",
      NothingToShow: "No hay mensajes para mostrar",
      errorLimitExceeded: "El usuario ha alcanzado el límite de deseos",
      Languages: "Idiomas",
      Theme: "Tema",
      Mode1: "Modo claro",
      Mode2: "Modo oscuro",
      Footer: "Esperamos verte pronto",
      Form: {
        Email: "Correo",
        Placeholderemail: "Ingresa tu correo",
        Name: "Nombre",
        PlaceholderName: "Ingresa tu nombre",
        LastName: "Apellido",
        PlaceholderLastname: "Ingresa tu apellido",
        registredEmail: "Tu email ya esta registrado",
      },
      ConfirmationMessage:
        "Estamos felices que te nos uniras, nos vemos el 20 de julio 2024. Gracias por tu confirmación",
      pageTitle: {
        landing: "Invitacion | Boda Georgi & Eli",
        details: "Detalles de cuenta | Boda Georgi & Eli",
        presential: "Confirmacion presencial | Boda Georgi & Eli",
        online: "Confirmatcon en linea | Boda Georgi & Eli",
        confirmation: "Confirmacion | Wedding Georgi & Eli",
        wishes: "Buenos deseos | Boda Georgi & Eli",
      },
    },
    Navbar: {
      Title: "Inicio",
      OurStory: "Nuestra historia",
      Schedule: "Agenda",
      Photos: "Fotos",
      Entourage: "Séquito",
      YourWishes: "Buenos Deseos",
      Gifts: "Regalos",
    },
    WelcomeSection: {
      weddingTitle: "Boda",
      pageTitle: "{wedding} Georgi & Eli",
      counter: {
        days: "Días",
        hours: "Hr",
        minutes: "Min",
        seconds: "Seg",
      },
      weddingLocation: "El Salvador",
      weddingDate: "20 de Julio, 2024",
      WelcomeMessage:
        "Bienvenidos a nuestro sitio web dedicado a nuestra boda, estamos contentos de compartir este momento especial contigo.",
      Subtitle: "Confirmar mi asistencia",
    },
    historySection: {
      title: "Nuestra historia",
      subtitleHowWeMet: "Cómo nos conocimos:",
      paragraph1:
        "En 2021 San Salvador, empieza la historia, nuestro primer encuentro nada más y nada menos que en el trabajo, sin planearlo, el amor llegó.",
      paragraph2:
        "A finales de ese año empezamos nuestra relación a distancia uno en El Salvador y otro en Francia, con citas por video llamadas y pelis en línea…las diferencias horarias no son nuestras amigas",
      paragraph3:
        "En 2022 los dos seguimos nuestra relación a distancia pero ahora en un mismo continente y mismos horarios, pequeñas escapadas a Madrid y Lille para vernos fueron parte de nuestra rutina.",
      subtitleTheProposal: "La propuesta",
      paragraph4:
        "En marzo 2023, en una ciudad llamada Toledo, un fin de semana inolvidable, donde se hizo la pregunta del millon en una terraza con una vista espectacular, ambos dijimos sí a un futuro juntos.",
    },
    ScheduleSection: {
      title: "Agenda",
      subtitlePresential: "Presencial",
      Time: "Hora",
      Hours: "18:00 pm a 22:30 pm",
      Direction: "Dirección",
      Adresse:
        '"Casa La Novena" 9na Calle Poniente #4919 Colonia Escalón, San Salvador. El Salvador',
      subtitleOnline: "En línea",
      Text: "Si no puedes estar presencialmente, puedes conectarte a nuestra reunión, donde transmitiremos la ceremonia y parte de nuestra celebración.",
    },
    PhotosSection: {
      title: "Algunas fotos de nuestra historia",
      Text: "Las fotos de la boda estarán disponibles",
      Here: "aquÍ",
    },
    EntourageSection: {
      title: "Acompañantes",
      subtitle1: "Damas",
      subtitle2: "Padrinos",
    },
    WhishesSection: {
      title: "Tus buenos deseos",
      paragraph:
        "Puedes dejarnos un mensaje aquí. Lo leeremos con mucho amor y apreciaremos tus pensamientos y cariño.",
      Text1:
        "Esta sección está reservada para tus deseos de corazón hacia nosotros.",
      Text2: "Puedes ver todos los buenos deseos",
      Text4: "aquí",
      Text3: "Gracias por tus buenos deseos",
      Form: {
        name: "Nombre",
        message: "Tu mensaje para nosotros",
      },
    },
    GiftSection: {
      title: "Tu presencia es un regalo",
      paragraph1:
        "Tu presencia es ya un regalo para nosotros y estaremos felices de verlos presencialmente o conectados en línea.",
      paragraph2:
        "Sin embargo, si quieres darnos un regalo puedes hacerlo de la siguiente manera:",
      subtitle1: "Regalo de sobre",
      paragraph3:
        "El día de la boda tendremos un buzón donde puedes dejar tu sobre.",
      subtitle2: "Transferencia bancaria",
      paragraph4:
        "Si es más fácil para ti, puede hacer la transferencia bancaria a una de las siguientes cuentas.",
      france: "Francia",
    },
    FormSection: {
      title: "Confirmar mi asistencia",
      Message1: {
        paragraph1:
          "Estamos alegres de saber que estarás presente y celebrarás junto a nosotros. Recuerda respetar el número de invitados que te indicamos por mensaje privado. Si tienes algún cambio en tu agenda, por motivos de coordinación, porfavor informarnos con la mayor anticipación posible",
        paragraph2:
          "Porfavor confirma tu nombre y apellido para nuestros registros.",
      },
      Message2: {
        paragraph3:
          "Aún en la distancia, estamos felices de saber que estaras presente.Puedes confirmar tu asistencia y conectarte a la transmisión en línea el día de la boda, te mandaremos el link por medio de tu correo electrónico.",
      },
    },
    PhotosPage: {
      notYet: "Estaran disponibles despues de la boda",
    },
    imagesAlt: {
      logo: "Logo con un círculo y las letras G y C en el medio",
      PhotoLandingPage: "Fotografía de Eliseo y Georgina",
      PhotoOurStory: "Fotografía nuestra historia",
      PhotoTheProposal: "Fotografía propuesta Eliseo y Georgina",
      PhotosNotreVie1: "Fotografía en Toledo",
      PhotosNotreVie2: "Fotografía con pintura en Madrid",
      PhotosNotreVie3: "Fotografía en París",
      PhotosNotreVie4: "Fotografía en Dunkerque",
      PhotosNotreVie5: "Fotografía navidad en Lille",
      PhotosNotreVie6: "Fotografía navidad en Madrid",
      PhotosNotreVie7: "Fotografía en Valencia",
      PhotosNotreVie8: "Fotografía en Salamanca",
      PhotoBridesmaid1: "Fotografía Lucía",
      PhotoBridesmaid2: "Fotografía Alexia",
      PhotoBridesmaid3: "Fotografía Keren",
      PhotoBridesmaid4: "Fotografía Geral",
      PhotoGroomsmen1: "FotografíaAlex",
      PhotoGroomsmen2: "FotografíaKevin",
      PhotoGroomsmen3: "FotografíaWilliam",
      PhotoGroomsmen4: "FotografíaChele",
    },
    IconsAlt: {
      iconBurguer: "Icono de menu",
      iconLocation: "Icono de localización",
      iconCalendar: "Icono de calendario",
      iconHeart: "Icono de corazón",
      iconClock: "Icono de reloj",
      iconRing: "Icono de anillo",
      iconEnvelope: "Icono de sobre",
      iconTransfer: "Icono de transferencia",
    },
    Buttons: {
      YoutubeLink: "Mirar la transmisión",
      PresentialButton: "Presencial",
      OnlineButton: "En línea",
      MapButton: "Mapa",
      CalendarButton: "Agendar",
      MessageButton: "Deja tu mensaje",
      AccountButton: "Ver detalles",
      ConfirmButton: "Confirmar",
      PostButton: "Postear",
    },
  },
  EN: {
    Common: {
      AccessCode: "Access code",
      NothingToShow: "No messages to show",
      errorLimitExceeded: "User has reached the wish limit",
      Languages: "Languages",
      Theme: "Theme",
      Mode1: "Light mode",
      Mode2: "Dark mode",
      Footer: "We hope to see you soon",
      Form: {
        Email: "Email",
        Placeholderemail: "Enter your email",
        Name: "Name",
        PlaceholderName: "Enter your name",
        LastName: "Last Name",
        PlaceholderLastname: "Enter your last name",
        registredEmail: "Your email is already registred",
      },
      ConfirmationMessage:
        "We are happy that you will join us, see you on July 20, 2024. Thank you for your confirmation",
      pageTitle: {
        landing: "Invitation | Wedding Georgi & Eli",
        details: "Bank details | Wedding Georgi & Eli",
        presential: "Presential confirmation | Wedding Georgi & Eli",
        online: "Online corfirmation | Wedding Georgi & Eli",
        confirmation: "Confirmation | Wedding Georgi & Eli",
        wishes: "Good Wishes | Mariage Georgi & Eli",
      },
    },
    Navbar: {
      Title: "Home",
      OurStory: "Our story",
      Schedule: "Schedule",
      Photos: "Photos",
      Entourage: "Entourage",
      YourWishes: "Your wishes",
      Gifts: "Gifts",
    },
    WelcomeSection: {
      weddingTitle: "Wedding",
      pageTitle: "{wedding} Georgi & Eli",
      counter: {
        days: "Days",
        hours: "Hr",
        minutes: "Min",
        seconds: "Sec",
      },
      weddingLocation: "El Salvador",
      weddingDate: "July 20, 2024",
      WelcomeMessage:
        "Welcome to our website dedicated to our wedding, we are happy to share this special moment with you.",
      Subtitle: "Confirm my attendance",
    },
    historySection: {
      title: "Our story",
      subtitleHowWeMet: "How we met:",
      paragraph1:
        "In 2021 San Salvador, the story begins, our first encounter was nothing more and nothing less than at work, unplanned, love arrived.",
      paragraph2:
        "At the end of that year, we started our long-distance relationship, one in El Salvador and the other in France, with video call dates and online movies... time differences are not our friends",
      paragraph3:
        "In 2022, we both continued our long-distance relationship but now on the same continent and in the same time zones, small getaways to Madrid and Lille to see each other were part of our routine.",
      subtitleTheProposal: "The proposal",
      paragraph4:
        "In March 2023, in a city called Toledo, an unforgettable weekend, where the million-dollar question was asked on a terrace with a spectacular view, we both said yes to a future together.",
    },
    ScheduleSection: {
      title: "Schedule",
      subtitlePresential: "Presential",
      Time: "Time",
      Hours: "6:00 pm to 10:30 pm",
      Direction: "Address",
      Adresse:
        '"Casa La Novena" 9na Calle Poniente #4919 Colonia Escalón, San Salvador. El Salvador',
      subtitleOnline: "Online",
      Text: "If you cannot be present in person, you can join to our meeting, where we will broadcast the ceremony and part of our celebration.",
    },
    PhotosSection: {
      title: "Some photos of our story",
      Text: "Wedding photos will be available",
      Here: "here",
    },
    EntourageSection: {
      title: "Entourage",
      subtitle1: "Bridesmaids",
      subtitle2: "Groomsmen",
    },
    WhishesSection: {
      title: "Your good wishes",
      paragraph:
        "You can leave us a message here. We will read it with much love and appreciate your thoughts and affection.",
      Text1: "This section is reserved for your heartfelt wishes for us.",
      Text2: "You can see all the good wishes",
      Text4: "here",
      Text3: "Thank you for your good wishes",
      Form: {
        name: "Name",
        message: "Your message for us",
      },
    },
    GiftSection: {
      title: "Your presence is a gift",
      paragraph1:
        "Your presence is already a gift for us and we will be happy to see you either in person or connected online.",
      paragraph2:
        "However, if you want to give us a gift you can do it in the following ways:",
      subtitle1: "Envelope gift",
      paragraph3:
        "On the wedding day, we will have a mailbox where you can leave your envelope.",
      subtitle2: "Bank transfer",
      paragraph4:
        "If it is easier for you, you can make the bank transfer to one of the following accounts.",
      france: "France",
    },
    FormSection: {
      title: "Confirm my attendance",
      Message1: {
        paragraph1:
          "We are happy to know that you will be present and will celebrate with us. Remember to respect the number of guests indicated by private message. If you have any changes in your schedule, for coordination reasons, please inform us as soon as possible",
        paragraph2: "Please confirm your first and last name for our records.",
      },
      Message2: {
        paragraph3:
          "Even from afar, we are happy to know that you will be present. You can confirm your attendance and connect to the online meeting on the wedding day, we will send you the link through your email.",
      },
    },
    PhotosPage: {
      notYet: "They'll be available after the wedding...",
    },
    imagesAlt: {
      logo: "Logo with a circle and the letters G and C in the middle",
      PhotoLandingPage: "Photograph of Eliseo and Georgina",
      PhotoOurStory: "Photograph of our story",
      PhotoTheProposal: "Photograph proposal Eliseo and Georgina",
      PhotosNotreVie1: "Photograph in Toledo",
      PhotosNotreVie2: "Photograph with paint in Madrid",
      PhotosNotreVie3: "Photograph in Paris",
      PhotosNotreVie4: "Photograph in Dunkirk",
      PhotosNotreVie5: "Christmas photograph in Lille",
      PhotosNotreVie6: "Christmas photograph in Madrid",
      PhotosNotreVie7: "Photograph in Valencia",
      PhotosNotreVie8: "Photograph in Salamanca",
      PhotoBridesmaid1: "Photograph of Lucía",
      PhotoBridesmaid2: "Photograph of Alexia",
      PhotoBridesmaid3: "Photograph of Keren",
      PhotoBridesmaid4: "Photograph of Geral",
      PhotoGroomsmen1: "Photograph of Alex",
      PhotoGroomsmen2: "Photograph of Kevin",
      PhotoGroomsmen3: "Photograph of William",
      PhotoGroomsmen4: "Photograph of Chele",
    },
    IconsAlt: {
      iconBurguer: "Menu icon",
      iconLocation: "Location icon",
      iconCalendar: "Calendar icon",
      iconHeart: "Heart icon",
      iconClock: "Clock icon",
      iconRing: "Ring icon",
      iconEnvelope: "Envelope icon",
      iconTransfer: "Transfer icon",
    },
    Buttons: {
      YoutubeLink: "Watch the stream",
      PresentialButton: "Presential",
      OnlineButton: "Online",
      MapButton: "Map",
      CalendarButton: "Add to calendar",
      MessageButton: "Leave your message",
      AccountButton: "View details",
      ConfirmButton: "Confirm",
      PostButton: "Post",
    },
  },
  FR: {
    Common: {
      AccessCode: "Code d'accès",
      NothingToShow: "Pas de messages à afficher",
      errorLimitExceeded: "L'utilisateur a atteint la limite de voeux",
      Languages: "Langues",
      Theme: "Thème",
      Mode1: "Mode clair",
      Mode2: "Mode sombre",
      Footer: "Nous espérons vous voir bientôt",
      Form: {
        Email: "Email",
        Placeholderemail: "Entrez votre email",
        Name: "Nom",
        PlaceholderName: "Entrez votre prénom",
        LastName: "Nom de famille",
        PlaceholderLastname: "Entrez votre nom de famille",
        registredEmail: "Votre email est déjà enregistré",
      },
      ConfirmationMessage:
        "Nous sommes heureux que vous vous joigniez à nous, rendez-vous le 20 juillet 2024. Merci pour votre confirmation",
      pageTitle: {
        landing: "Invitation | Mariage Georgi & Eli",
        details: "Details de compte bancaire| Mariage Georgi & Eli",
        presential: "Confirmation présentiel | Mariage Georgi & Eli",
        online: "Confirmation à distanciel | Mariage Georgi & Eli",
        confirmation: "Confirmation | Wedding Georgi & Eli",
        wishes: "Vos bons vœux | Mariage Georgi & Eli",
      },
    },
    Navbar: {
      Title: "Accueil",
      OurStory: "Notre histoire",
      Schedule: "Programme",
      Photos: "Photos",
      Entourage: "Entourage",
      YourWishes: "Vos vœux",
      Gifts: "Cadeaux",
    },
    WelcomeSection: {
      weddingTitle: "Mariage",
      pageTitle: "{wedding} Georgi & Eli",
      counter: {
        days: "Jours",
        hours: "Hr",
        minutes: "Min",
        seconds: "Sec",
      },
      weddingLocation: "El Salvador",
      weddingDate: "20 juillet 2024",
      WelcomeMessage:
        "Bienvenue sur notre site web dédié à notre mariage, nous sommes heureux de partager ce moment spécial avec vous.",
      Subtitle: "Confirmer ma présence",
    },
    historySection: {
      title: "Notre histoire",
      subtitleHowWeMet: "Comment nous nous sommes rencontrés:",
      paragraph1:
        "En 2021 à San Salvador,l'histoire commence, notre première rencontre était rien de moins qu'au travail, non planifiée, l'amour est arrivé.",
      paragraph2:
        "À la fin de cette année-là, nous avons commencé notre relation à distance, l'un au Salvador et l'autre en France, avec des rendez-vous vidéo et des films en ligne... les différences horaires ne sont pas nos amies",
      paragraph3:
        "En 2022, nous avons continué notre relation à distance mais maintenant sur le même continent et dans les mêmes fuseaux horaires, de petites escapades à Madrid et à Lille pour nous voir faisaient partie de notre routine.",
      subtitleTheProposal: "La proposition",
      paragraph4:
        "En mars 2023, dans une ville appelée Tolède, un week-end inoubliable, où la question à un million a été posée sur une terrasse avec une vue spectaculaire, nous avons tous les deux dit oui à un avenir ensemble.",
    },
    ScheduleSection: {
      title: "Programme",
      subtitlePresential: "En personne",
      Time: "Heure",
      Hours: "18h00 à 22h30",
      Direction: "Adresse",
      Adresse:
        '"Casa La Novena" 9na Calle Poniente #4919 Colonia Escalón, San Salvador. El Salvador',
      subtitleOnline: "En ligne",
      Text: "Si vous ne pouvez pas être présent en personne, vous pouvez vous connecter à notre réunion, où nous diffuserons la cérémonie et une partie de notre célébration.",
    },
    PhotosSection: {
      title: "Quelques photos de notre histoire",
      Text: "Les photos de mariage seront disponibles",
      Here: "ici",
    },
    EntourageSection: {
      title: "Entourage",
      subtitle1: "Demoiselles d'honneur",
      subtitle2: "Témoins",
    },
    WhishesSection: {
      title: "Vos bons vœux",
      paragraph:
        "Vous pouvez nous laisser un message ici. Nous le lirons avec beaucoup d'amour et apprécierons vos pensées et votre affection.",
      Text1: "Cette section est réservée à vos vœux sincères pour nous.",
      Text2: "Vous pouvez voir tous les bons vœux",
      Text4: "ici",
      Text3: "Merci pour vos bons vœux",
      Form: {
        name: "Nom",
        message: "Votre message pour nous",
      },
    },
    GiftSection: {
      title: "Votre présence est un cadeau",
      paragraph1:
        "Votre présence est déjà un cadeau pour nous et nous serons heureux de vous voir soit en personne, soit connecté en ligne.",
      paragraph2:
        "Cependant, si vous voulez nous offrir un cadeaux, vous pouvez le faire de la manière suivante :",
      subtitle1: "Cadeau d'enveloppe",
      paragraph3:
        "Le jour du mariage, nous aurons une boîte aux lettres où vous pourrez laisser votre enveloppe.",
      subtitle2: "Virement bancaire",
      paragraph4:
        "Si c'est plus facile pour vous, vous pouvez effectuer le virement bancaire sur l'un des comptes suivants.",
      france: "France",
    },
    FormSection: {
      title: "Confirmer ma présence",
      Message1: {
        paragraph1:
          "Nous sommes heureux de savoir que vous serez présent et que vous célébrerez avec nous. N'oubliez pas de respecter le nombre d'invités indiqué par message privé. Si vous avez des changements dans votre emploi du temps, pour des raisons de coordination, veuillez nous en informer dès que possible",
        paragraph2:
          "Nous vous demandons de bien vouloir confirmer votre nom et prénom pour nos registres.",
      },
      Message2: {
        paragraph3:
          "Même de loin, nous sommes heureux de savoir que vous serez présent. Vous pouvez confirmer votre présence et vous connecter à la diffusion en ligne le jour du mariage, nous vous enverrons le lien par e-mail.",
      },
    },
    PhotosPage: {
      notYet: "Elles seront disponibles après le mariage",
    },
    imagesAlt: {
      logo: "Logo avec un cercle et les lettres G et C au milieu",
      PhotoLandingPage: "Photographie d'Eliseo et Georgina",
      PhotoOurStory: "Photographie de notre histoire",
      PhotoTheProposal: "Photographie de la proposition Eliseo et Georgina",
      PhotosNotreVie1: "Photographie à Tolède",
      PhotosNotreVie2: "Photographie avec de la peinture à Madrid",
      PhotosNotreVie3: "Photographie à Paris",
      PhotosNotreVie4: "Photographie à Dunkerque",
      PhotosNotreVie5: "Photographie de Noël à Lille",
      PhotosNotreVie6: "Photographie de Noël à Madrid",
      PhotosNotreVie7: "Photographie à Valence",
      PhotosNotreVie8: "Photographie à Salamanque",
      PhotoBridesmaid1: "Photographie de Lucía",
      PhotoBridesmaid2: "Photographie de Alexia",
      PhotoBridesmaid3: "Photographie de Keren",
      PhotoBridesmaid4: "Photographie de Geral",
      PhotoGroomsmen1: "Photographie de Alex",
      PhotoGroomsmen2: "Photographie de Kevin",
      PhotoGroomsmen3: "Photographie de William",
      PhotoGroomsmen4: "Photographie de Chele",
    },
    IconsAlt: {
      iconBurguer: "Icône de menu",
      iconLocation: "Icône de localisation",
      iconCalendar: "Icône de calendrier",
      iconHeart: "Icône de cœur",
      iconClock: "Icône d'horloge",
      iconRing: "Icône de bague",
      iconEnvelope: "Icône d'enveloppe",
      iconTransfer: "Icône de transfert",
    },
    Buttons: {
      YoutubeLink: "Regarder le stream",
      PresentialButton: "En personne",
      OnlineButton: "En ligne",
      MapButton: "Carte",
      CalendarButton: "Planifier",
      MessageButton: "Laissez votre message",
      PostButton: "Poster",
      AccountButton: "Voir les details",
      ConfirmButton: "Confirmer",
    },
  },
};

export default messages;
